<template>
    <div class="row">
        <div class="col-12">
            <div v-if="!status.list" class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="row mt-4">
                        <div class="col-sm-12 col-md-6 d-flex justify-content-start">
                            <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                <label class="d-inline-flex align-items-center">
                                    {{ $t("label.search") }}
                                    <b-form-input
                                        v-model="filter"
                                        type="search"
                                        :placeholder="$t('label.search')"
                                        class="form-control form-control-sm ml-2"
                                        @change="searchListing"
                                    />
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="row d-flex justify-content-end">
                                <div class="col-md-4"></div>
                                <div class="col-md-4 col-6 mb-2">
                                    <multiselect
                                        v-model="isActive"
                                        deselect-label=""
                                        track-by="value"
                                        label="text"
                                        :placeholder="$t('module.status')"
                                        :options="statusDdl"
                                        :searchable="true"
                                        :allow-empty="false"
                                        v-on:input="searchListing"
                                    ></multiselect>
                                </div>
                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-6">
                                            <button
                                                class="btn btn-info w-md waves-effect waves-light mr-2 mb-2"
                                                @click="searchListing"
                                            >
                                                <i class="mdi mdi-refresh"></i> {{ $t('label.refresh') }}
                                            </button>
                                        </div>
                                        <div class="col-6">
                                            <button
                                                class="btn btn-primary w-md waves-effect waves-light mr-2 mb-2"
                                                @click="toCreatePage"
                                            >
                                                {{ $t('label.createX', [$t('module.label')]) }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive mb-0">
                        <b-table
                            :items="tableRows"
                            :fields="fields"
                            responsive="sm"
                            :per-page="perPage"
                            v-if="readPermission == true"
                        >
                            <template #cell(product)="data">
                                {{ data.item.product.name }}
                            </template>
                            <template #cell(isActive)="data">
                                <b-form-checkbox
                                    @change="editStatus(tableRows[data.index])"
                                    :disabled="updateStatusPermission == false"
                                    v-model="tableRows[data.index].isActive"
                                    switch
                                    class="mb-1"
                                />
                            </template>
                            <!-- <template #cell(images)="data">
                                <div class="image-scroll">
                                    <img
                                        v-for="(img, index) in data.item.images"
                                        :key="index"
                                        :src="img.imageUrl"
                                        class="table-image border border-light"
                                    />
                                </div>
                            </template> -->
                            <template #cell(action)="data">
                                <a
                                    v-if="readPermission == true && updatePermission == true"
                                    href="javascript:void(0);"
                                    :class="currentUser == tableRows[data.index].email ? 'disabled text-warning' : 'text-primary'"
                                    @click="toDetailsPage(tableRows[data.index].id)"
                                    v-b-tooltip.hover
                                    title="Edit"
                                >
                                    <i class="mdi mdi-pencil font-size-18"></i>
                                </a>
                                <a
                                    v-if="readPermission == true && updatePermission != true"
                                    href="javascript:void(0);"
                                    :class="currentUser == tableRows[data.index].email ? 'disabled text-warning' : 'text-primary'"
                                    @click="toDetailsPage(tableRows[data.index].uuid)"
                                    v-b-tooltip.hover
                                    style="margin-left: 5px;"
                                    title="Edit"
                                >
                                    <i class="mdi mdi-file-search-outline font-size-18"></i>
                                </a>
                            </template>
                        </b-table>
                        <div
                            v-else
                            class="row d-flex justify-content-center align-items-center"
                        >
                            {{ $t('message.noPermissionMessage') }}
                        </div>
                    </div>
                    <div
                        v-if="readPermission == true"
                        class="row"
                    >
                        <div class="col">
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalPage"
                                        :per-page="perPage"
                                        @change="pageNavigation"
                                    />
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import i18n from "@/i18n";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION, SHARED } from "@/constants";
import { productLabelNewMethods } from "@/state/helpers";
import { PRODUCT_LABEL_MODULE_NEW } from '@/state/modules/productLabelNew';
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
    props: {
        triggerSearch: { // productID
            type: String,
            default: null,
        },
        triggerSearchName: { // productName
            type: String,
            default: null,
        },
        triggerTab: {
            type: String,
            default: null,
        }
    },
    components: { Multiselect },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'Product-label-update' && to.name != 'Product-label-create') {
            sessionHelper.clearSearch(SESSION.PRODUCT_LABEL_SEARCH)
        }
        next();
    },
    async created() {
        await this.validPermissions();
        this.initSearchCriteria();
    },
    data() {
        return {
            accountLockStatusDdl: ddlHelper.getAccountLockStatus(true),
            currentUser: sessionHelper.getUserEmail(),
            readPermission: null,
            updateStatusPermission: null,
            permissions: sessionHelper.getPermissions(),
            filter: "",
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: ddlHelper.getActivationStatus(true)[1],
            fields: [
                { key: 'product', label: i18n.t('module.product') },
                // { key: 'images', label: i18n.t('module.label') },
                { key: "dateFormat", sortable: true, label: i18n.t("label.date"), },
                { key: "isActive", sortable: false, label: i18n.t("label.status"), },
                { key: "Action", sortable: false, label: i18n.t("label.action"), },
            ],
        };
    },
    methods: {
        ...productLabelNewMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_PLABEL_PLC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PLABEL_PLR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PLABEL_PLU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PLABEL_PLUS")) {
                this.updateStatusPermission = true;
            }
            else {
                this.updateStatusPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PLABEL_PLD")) {
                this.downloadPermission = true;
            }
            else {
                this.downloadPermission = false;
            }
        },
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.PRODUCT_LABEL_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_LABEL_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: this.isActive.value,
                    searchValue: "",
                    searchArray: [],
                };
            }
            if (this.triggerSearch) {
                this.searchCriteria.productID = this.triggerSearch;
            }
            this.getProductLabelList(this.searchCriteria);
        },
        getProductLabelList(filter) {
            this.getAllProductLabelsNew({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.PRODUCT_LABEL_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.PRODUCT_LABEL_SEARCH);
            filter.pageNumber = pageNumber;
            this.getProductLabelList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            this.searchCriteria.isActive = this.isActive.value;
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getProductLabelList(this.searchCriteria);
        },
        toDetailsPage(id) {
            let filter = sessionHelper.retrieveSearch(SESSION.PRODUCT_LABEL_SEARCH);
            filter.selectedRecordId = id;
            filter.previousPageName = this.$route.name;
            sessionHelper.storeSearch(SESSION.PRODUCT_LABEL_SEARCH, filter);

            if (this.$route.name == 'Product-label-listing') {
                this.$router.push({
                    name: 'Product-label-update',
                });
            } else {
                const routeData = this.$router.resolve({
                    name: 'Product-label-update'
                });
                window.open(routeData.href, '_blank');
            }
        },
        toCreatePage() {
            let filter = sessionHelper.retrieveSearch(SESSION.PRODUCT_LABEL_SEARCH);
            filter.selectedRecordId = "";
            filter.productID = {
                value: this.triggerSearch,
                text: this.triggerSearchName,
            };
            filter.previousPageName = this.$route.name;
            sessionHelper.storeSearch(SESSION.PRODUCT_LABEL_SEARCH, filter);

            if (this.$route.name == 'Product-label-listing') {
                this.$router.push({
                    name: 'Product-label-create',
                });
            } else {
                const routeData = this.$router.resolve({
                    name: 'Product-label-create'
                });
                window.open(routeData.href, '_blank');
            }
            
        },
        editStatus(image) {
			let data = {
                id: image.id,
				isActive: image.isActive ? 1 : 0,
			}
			this.updateProductLabelStatusNew({data, filter: this.searchCriteria});
        },
    },
    computed: {
        ...mapState(PRODUCT_LABEL_MODULE_NEW, ['status']),
        tableRows() {
            return this.$store.state.productLabelNew.list.data || [];
        },
        totalPage() {
            return this.$store.state.productLabelNew.list.pagination.total || 0;
        },
    },
}
</script>
<style>

.image-scroll {
    display: flex;
    gap: 8px;
    max-width: 700px;          /* limit column width */
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 4px;
}

/* Hide ugly scrollbar (optional) */
.image-scroll::-webkit-scrollbar {
  height: 6px;
}
.image-scroll::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
}

.table-image {
    width: 120px;
    height: 60px;
    min-width: 120px;           /* prevents shrinking */
    object-fit: cover;        /* crop instead of stretch */
    border-radius: 6px;
    border: 1px solid #e5e5e5;
    cursor: pointer;
    background-color: #f8f9fa;
}


</style>